<template>
  <div>
    <template v-for="item in details">
      <b-card class="vsa-card-border-gray mb-2">
        <template v-for="(element, key) in item">
          <dl class="row mb-0" v-if="element">
            <dt class="col-sm-3 fs-900 fw-500 mb-0">
              {{ fnGetSnakeToTitle(key) }}
            </dt>
            <dd class="col-sm-9 fs-900 mb-0">
              <template>
                <span v-if="key == 'note'" v-html="element"></span>
                <span v-else>{{ element }}</span>
              </template>
            </dd>
          </dl>
        </template>
      </b-card>
    </template>
  </div>
</template>
  <script>
import { fnSnakeToTitle } from '../../services/sharedFn.service'

export default {
  name: 'WDVsaQuoteLeadsLogs',
  props: {
    details: {
      type: Array,
      default: []
    }
  },
  methods: {
    fnGetSnakeToTitle(str) {
      return fnSnakeToTitle(str)
    }
  }
}
</script>